var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.75C6.09375 12.75 6 12.6562 6 12.5V11.5C6 11.375 6.09375 11.25 6.25 11.25H10.75C10.875 11.25 11 11.375 11 11.5V12.5C11 12.6562 10.875 12.75 10.75 12.75H6.25ZM3.5 13C3.21875 13 3 12.7812 3 12.5V11.5C3 11.25 3.21875 11 3.5 11H4.5C4.75 11 5 11.25 5 11.5V12.5C5 12.7812 4.75 13 4.5 13H3.5ZM3.5 9C3.21875 9 3 8.78125 3 8.5V7.5C3 7.25 3.21875 7 3.5 7H4.5C4.75 7 5 7.25 5 7.5V8.5C5 8.78125 4.75 9 4.5 9H3.5ZM6.25 8.75C6.09375 8.75 6 8.65625 6 8.5V7.5C6 7.375 6.09375 7.25 6.25 7.25H10.75C10.875 7.25 11 7.375 11 7.5V8.5C11 8.65625 10.875 8.75 10.75 8.75H6.25ZM3.5 5C3.21875 5 3 4.78125 3 4.5V3.5C3 3.25 3.21875 3 3.5 3H4.5C4.75 3 5 3.25 5 3.5V4.5C5 4.78125 4.75 5 4.5 5H3.5ZM6.25 4.75C6.09375 4.75 6 4.65625 6 4.5V3.5C6 3.375 6.09375 3.25 6.25 3.25H10.75C10.875 3.25 11 3.375 11 3.5V4.5C11 4.65625 10.875 4.75 10.75 4.75H6.25ZM13 0C13.5312 0 14 0.46875 14 1V15C14 15.5625 13.5312 16 13 16H1C0.4375 16 0 15.5625 0 15V1C0 0.46875 0.4375 0 1 0H13ZM12.5 14.5V1.5H1.5V14.5H12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingList);
export default __webpack_public_path__ + "static/media/shoppingList.dc002e896d7442af358fe69bd3773180.svg";
export { ForwardRef as ReactComponent };